import React, { forwardRef, ReactNode } from 'react';
import classnames from 'classnames';
import './DemographicsStep.scss';
import { ByzzerButton, StepRef, WizardActions, WizardContent, WizardHeader, WizardStep } from '@byzzer/ui-components';
import { DemographicsFilter, DemographicsFiltersProps } from './DemographicsFilter';

export type DemographicsStepProps = {
    title?: ReactNode;
    onComplete?: () => void;
    onCancel?: () => void;
    enabled?: boolean;
    disableSave?: boolean;
    saveDisabledTip?: string;
} & DemographicsFiltersProps;

export const DemographicsStep = forwardRef<StepRef, DemographicsStepProps>(
    ({ className, title, onComplete, enabled, onCancel, disableSave, saveDisabledTip, ...props }, ref) => {

        const baseClassName = 'byz-demographics-step';

        function handleCancelClick() {
            onCancel?.();
        }

        function handleComplete(): boolean {
            onComplete?.();
            return false;
        }

        return (
            <WizardStep className={classnames(baseClassName, className)} ref={ref} title={title} enabled>
                <WizardHeader>
                    <h1 className={'report-run-config-wizard__step-title'}>{title}</h1>
                </WizardHeader>

                <WizardContent>{<DemographicsFilter {...props} />}</WizardContent>

                <WizardActions nextText="Save" beforeNext={handleComplete} disableNext={disableSave} nextDisabledTip={saveDisabledTip}>
                    <ByzzerButton onClick={handleCancelClick} type={'negative'}>
                        Cancel
                    </ByzzerButton>
                </WizardActions>
            </WizardStep>
        );
    }
);

export default DemographicsStep;
DemographicsStep.displayName = 'DemographicsStep';
